import React from "react";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";

import { IRadioStyleType, RadioGroupFormControl } from "../Web/RadioGroupFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: RadioGroupFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let radiogroup = new RadioGroupFormControl();
    radiogroup.valueName = "radio";
    radiogroup.list = [
        "Operator",
        "Manager",
        "Administration",
        "UX/UI designer",
        "Back-end developer",
        "Project-manager",
    ];
    container.add(radiogroup);

    return { form: ui, control: radiogroup };
}

export const RadioGroupStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Default Control";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Radio Group",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "With Value";
            let data = new ExecutionData();
            data.values["radio"] = "Operator";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Radio Group",
        "With Value",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            ui.control.label = "With Checkbox";
            ui.control.styleType = IRadioStyleType.CHECKBOX;
            data = new ExecutionData();
            data.values["radio"] = "Operator";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Radio Group",
        "With Checkbox",
    ),
];
